import { render, staticRenderFns } from "./Tecnico.vue?vue&type=template&id=72b50f54&"
import script from "./Tecnico.vue?vue&type=script&lang=js&"
export * from "./Tecnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports